import type { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import { BrainRail } from './BrainRail';

// ── YC demo: Plan 05 ────────────────────────────────────────────────────
// /brain default landing now resolves to /brain/memory ("Things Jacinta has
// learned"). The redirect itself lives in page-registry.tsx (kind:
// 'brain-redirect') — this layout still just renders the rail + outlet.
// ────────────────────────────────────────────────────────────────────────
export function BrainLayout({ children }: { children?: ReactNode }) {
  return (
    <div className="ats-fullscreen-shell">
      <BrainRail />
      <div className="ats-fullscreen-content">{children ?? <Outlet />}</div>
    </div>
  );
}
